/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useEffect, useMemo, useState} from 'react'
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {Button, ButtonWrapper} from '../../../../../../components/UI/Button'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {CheckInFiltersModel} from '../../../../model'
import {FormProvider, useForm} from 'react-hook-form'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {CheckingModel} from '../../../../../hoteleria/models/ckecking.model'
// import ActionsContent from '../../../../pages/components/Actions'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {CampModel, ClientModel, CompanyModel, SiteModel} from '../../../../../central/model'
import {getCamp, getClient, getCompany, getSite} from '../../../../../central/services'
import {getMasterModuleService} from '../../../../../hoteleria/features/modules/services'
// import {getRoomsService} from '../../../room/services'
import {paginationGuestsService} from '../../../../../hoteleria/features/guests/services'
import {getCheckingService} from '../../../../../hoteleria/services/checking.service'
import {Select} from '../../../../../../components/UI/Select'
import {InputDate} from '../../../../../../components/UI/Input'
import {checkInSchema} from '../../../../../../util/validationHoteleria'
import {yupResolver} from '@hookform/resolvers/yup'

interface SelectOption {
  value: string | number | undefined
  label: string | undefined
}

const TableCheckIn: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    pagination,
    updateTable,
    setUpdateTable,
    clearTable,
    setClearTable,
  } = useKTable()
  const methods = useForm<CheckInFiltersModel>({
    resolver: yupResolver(checkInSchema),
  })
  const {
    control,
    formState: {errors},
    register,
    setValue,
    handleSubmit,
    setError,
    reset,
  } = methods
  const {setShowModalSearch} = useHoteleria()
  const {selectedOn} = useKTable()
  const {searchValues, clearSearchValues} = useKhipu()
  const [formValue, setFormValue] = useState<any>(null)
  const [compani, setCompany] = useState<SelectOption[]>([])
  const [client, setClient] = useState<SelectOption[]>([])
  const [site, setSite] = useState<SelectOption[]>([])
  const [camp, setCamp] = useState<SelectOption[]>([])
  const [bedTypes, setBedTypes] = useState<SelectOption[]>([])
  const [companyType, setCompanyType] = useState<SelectOption[]>([])
  const [statusType, setStatusType] = useState<SelectOption[]>([])
  const [guest, setGuest] = useState<SelectOption[]>([])

  const getCompanyList = async () => {
    let obj: CompanyModel = {
      isCombo: true,
    }
    const response = await getCompany(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({
      value: item.id,
      label: item.nombreEmpresa,
    }))
    setCompany(mappedSites)
  }

  const getClientList = async (id: string) => {
    let obj: ClientModel = {
      isCombo: true,
      companiaId: id,
    }
    const response = await getClient(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setClient(mappedSites)
  }

  const getSiteList = async (id: string) => {
    let obj: SiteModel = {
      isCombo: true,
      clienteId: id,
    }
    const response = await getSite(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setSite(mappedSites)
  }
  const getCampList = async (id: string) => {
    let obj: CampModel = {
      isCombo: true,
      siteId: id,
    }
    const response = await getCamp(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setCamp(mappedSites)
  }

  const getBedTypes = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoCama',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      setBedTypes(mappedMaster)
    } catch (error) {
      setBedTypes([])
    }
  }

  const getCompanyTypes = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoEmpresa',
      })
      const data = response.data.data
      const mappedModuleTypes = data?.map((moduleType) => ({
        value: moduleType.id,
        label: moduleType.nombreCorto,
      }))
      setCompanyType(mappedModuleTypes)
    } catch (error) {
      setCompanyType([])
    }
  }

  const getStatusTypes = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'EstadoReservaHuesped',
      })
      const data = response.data.data
      const filterData = data?.filter(
        (moduleType) => moduleType.codigo === '2' || moduleType.codigo === '3',
      )
      const mappedModuleTypes = filterData?.map((moduleType) => ({
        value: moduleType.id,
        label: moduleType.nombreCorto,
      }))
      setValue('EstadoReservaId', mappedModuleTypes?.[0].value)
      setStatusType(mappedModuleTypes)
    } catch (error) {
      setStatusType([])
    }
  }

  const getGuests = async (campId: string) => {
    try {
      const {data: response} = await paginationGuestsService({
        pageNumber: 1,
        size: 2000,
        CampamentoId: campId,
      })
      if (!response.error) {
        const mappedGuests = response.data?.map((guest) => ({
          value: guest.Id,
          label: `${guest.Nombres} ${guest.ApellidoPaterno} ${guest.ApellidoMaterno}`,
        }))
        setGuest(mappedGuests)
      }
    } catch (error) {
      setGuest([])
    }
  }

  ///

  const getChekings = async () => {
    setShowModalSearch(false)
    try {
      setLoading(true)
      // changeSearchValues({})
      const {data: response} = await getCheckingService({
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        // StatusCode: '2', //Checking
        ...formValue,
        ...searchValues,
      })
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const handleFilterClient = (e: any) => {
    let value = e.value
    getClientList(value)
    setValue('CompaniaId', value)
    setError('CompaniaId', {})
  }

  const handleFilterSite = (e: any) => {
    let value = e.value
    getSiteList(value)
    setValue('ClienteId', value)
    setError('ClienteId', {})
  }

  const handleFilterCamp = (e: any) => {
    let value = e.value
    getCampList(value)
    setValue('SiteId', value)
    setError('SiteId', {})
  }

  // useEffect(() => {
  //   if (Object.keys(searchValues).length === 0) {
  //     getChekings()
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [searchValues])

  useEffect(() => {
    // getChekings()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  const columns: Column<CheckingModel>[] = useMemo(
    () => [
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='N° Reserva'
            name='NroReserva'
            searcheable
            number
          />
        ),
        accessor: 'CodigoReserva',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Módulo' name='CodigoModulo' searcheable />
        ),
        accessor: 'Modulo',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Habitación' name='CodigoHabitacion' searcheable />
        ),
        accessor: 'Habitacion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Cama' name='CodigoCama' searcheable />
        ),
        accessor: 'CodigoCama',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de cama'
            name='TipoCamaId'
            selecteable
            data={bedTypes}
          />
        ),
        accessor: 'CamaTipo',
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Huesped'
            name='HuespedId'
            selecteable
            data={guest}
          />
        ),
        accessor: 'HuespedDescripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tip. Empresa'
            name='TipoEmpresaId'
            selecteable
            data={companyType}
          />
        ),
        accessor: 'TipoEmpresa',
      },

      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha Inicio' name='FechaIni' dateable />
        ),
        accessor: 'FechaInicio',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha Fin' name='FechaFin' dateable />
        ),
        accessor: 'FechaFin',
      },
    ],
    [bedTypes, guest, companyType, selectedOn],
  )
  useEffect(() => {
    if (updateTable) {
      getChekings()
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])

  useEffect(() => {
    getCompanyList()
    getBedTypes()
    getCompanyTypes()
    getStatusTypes()
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (clearTable) {
      setClient([])
      setSite([])
      setCamp([])
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])

  useEffect(() => {
    setLoading(loading)
    setLoading(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])
  useEffect(() => {
    if (formValue) {
      getChekings()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formValue])

  const handleClear = () => {
    setClient([])
    setSite([])
    setCamp([])
    reset()
    setFormValue(null)
    setData([])
    setClearTable(true)
    getStatusTypes()
  }

  const onSubmit = (dataForm: CheckInFiltersModel) => {
    setFormValue(dataForm)
  }
  return (
    <>
      <KTCard shadow className='m-5'>
        <>
          <FormProvider {...methods}>
            <form className='m-2'>
              <div className='row'>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Compañía:</label>
                  <Select
                    control={control}
                    name='CompaniaId'
                    data={compani}
                    errors={errors}
                    onChangeValue={handleFilterClient}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Cliente:</label>
                  <Select
                    control={control}
                    name='ClienteId'
                    data={client}
                    errors={errors}
                    onChangeValue={handleFilterSite}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Site:</label>
                  <Select
                    control={control}
                    name='SiteId'
                    data={site}
                    errors={errors}
                    onChangeValue={handleFilterCamp}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Campamento:</label>
                  <Select control={control} name='CampamentoId' data={camp} errors={errors} />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Estado de reserva:</label>
                  <Select
                    control={control}
                    name='EstadoReservaId'
                    data={statusType}
                    errors={errors}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label>Fecha Inicio de Reserva:</label>
                  <InputDate name='FechaIni' register={register} errors={errors} />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label>Fecha Fin de Reserva:</label>
                  <InputDate name='FechaFin' register={register} errors={errors} />
                </div>
              </div>
            </form>
            <ButtonWrapper className={'sdx-white-bg'}>
              <Button label='Guardar' onClick={handleSubmit(onSubmit)} />
              <Button label='Limpiar' onClick={handleClear} />
            </ButtonWrapper>
          </FormProvider>
        </>
        {loading ? <KTableLoading title='Cargando...' /> : null}
        <KTable data={data} columns={columns} clearFilters />
      </KTCard>
    </>
  )
}

const TableCheckInWrapper = () => {
  return (
    <KTableProvider>
      <div className=''>
        <TableCheckIn />
      </div>
    </KTableProvider>
  )
}

export {TableCheckInWrapper}
